import { createRestApiRequestHeaders } from 'owa-headers';
import { makeGetRequest } from 'owa-ows-gateway';
import { Settings } from '../schema/ScenarioSettings';
import { getWorkloadScenarioType } from '../utils/getWorkloadScenarioType';
import { createGetScenarioSettingUrl } from '../utils/createGetScenarioSettingsUrl';
import { isTimePanelSelectedViewResponseType } from '../schema/ScenarioSettings/TimePanelSelectedView';
import { isTimePanelCalendarIdsResponseType } from '../schema/ScenarioSettings/TimePanelCalendarIds';
import { isSupportedWorkload } from '../utils/isSupportedWorkload';
import { getOwaWorkload } from 'owa-workloads';
import { ScenarioType } from '../schema/ScenarioType';
import { isSelectedCalendarListViewResponseType } from '../schema/ScenarioSettings/SelectedCalendarListView';

/** get the settings for the current workload, and non-workload specific 'Owa' settings */
export async function getWorkloadScenarioSettings(accountSmtpAddress: string): Promise<Settings> {
    // get the settings url request for OWA and the current module
    const scenarios: ScenarioType[] = ['Owa'];
    const workload = getOwaWorkload();
    if (isSupportedWorkload(workload)) {
        const scenario = getWorkloadScenarioType(workload);
        scenarios.push(scenario);
    }
    const getUrl = createGetScenarioSettingUrl(scenarios);
    return createRestApiRequestHeaders(accountSmtpAddress).then(async headers => {
        const result = await makeGetRequest(
            getUrl,
            undefined /* correlationId */,
            undefined /* returnFullResponse */,
            headers /* customHeaders */,
            true /* throwServiceError */,
            undefined /* includeCredentials */,
            'GET_WORKLOAD_SCENARIO_SETTINGS'
        );
        const settings: Settings = {
            timePanelSelectedView: null,
            timePanelCalendarIds: [],
            timePanelSelectedCalendarView: null,
        };

        result.settings &&
            result.settings.forEach(setting => {
                if (isTimePanelCalendarIdsResponseType(setting)) {
                    settings.timePanelCalendarIds = setting.calendarIds;
                } else if (isTimePanelSelectedViewResponseType(setting)) {
                    settings.timePanelSelectedView = setting.selectedView;
                } else if (isSelectedCalendarListViewResponseType(setting)) {
                    settings.timePanelSelectedCalendarView = setting.selectedView;
                }
            });
        return settings;
    });
}
